import { FhirBinary } from '@oh-vcp/components-common';
import useFhirResourceEffect from './useFhirResourceEffect';

const useProcessedPatientFhirData = (
  configs: {
    data: any;
    setter: React.Dispatch<React.SetStateAction<string>>;
    type: string;
    setSelectedReports: React.Dispatch<React.SetStateAction<string[]>>;
    setBinaryItems: React.Dispatch<React.SetStateAction<FhirBinary[]>>;
    references?: any;
  }[],
  enabled: boolean = true
) => {
  configs.forEach(({ data, setter, type, setSelectedReports, setBinaryItems, references }) => {
    useFhirResourceEffect(
      data,
      setter,
      type,
      setSelectedReports,
      enabled,
      setBinaryItems,
      references
    );
  });
};

export default useProcessedPatientFhirData;
